module.exports = __webpack_public_path__ + "static/img/page4.ea60262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page4.png
// module id = KGTP
// module chunks = 2